import standardAction from '../../../utilities/standard-action';
import { ActionTypes } from '../constants';
import { RootActionTypes } from '../../../stores/types';

export default function setSelectedExport(
  exportItem: io.flow.v0.models.ScheduledExport,
): RootActionTypes {
  return standardAction(ActionTypes.SELECT_SCHEDULED_EXPORT, exportItem);
}
